class AddPremiumDialogController {
  constructor($mdDialog, $mdToast, Post, Premium, Category, products) {
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.Post = Post;
    this.Premium = Premium;
    this.Category = Category;
    this.products = products;
    // console.log(this.products);
  }
  $onInit() {
    const { Category, products } = this;
    this.addProduct = products.find(product => product.premium.position === 'front');
    Category.getParents().then((response) => {
      this.categories = response;
    });
  }
  onChooseProduct() {
    const product = this.products.find(p => p._id === this.premium.product);
    this.showCategory = product.premium && product.premium.position === 'category';
  }
  close() {
    const { $mdDialog } = this;
    $mdDialog.hide();
  }
  getPostId(id) {
    const { Post } = this;
    Post.getById(id).then((post) => {
      this.post = post;
    });
  }
  add({
    postId, product, days, isAds, category,
  }) {
    const { Premium, $mdToast } = this;

    Premium.add({
      post: postId,
      product,
      days,
      isAds,
      category,
    }).then((salehistory) => {
      $mdToast.show($mdToast.simple().textContent('Premium agregado satisfactoriamente'));
      this.close(salehistory);
    });
  }
  // onPositionChange(position) {
  //   if (position === 'category') {
  //   } else {
  //   }
  // }
  // onCategoryChange() {}
}
AddPremiumDialogController.$inject = [
  '$mdDialog',
  '$mdToast',
  'Post',
  'Premium',
  'Category',
  'products',
];
export default AddPremiumDialogController;



// WEBPACK FOOTER //
// ./client/app/components/premium/add-premium/add.premium.dialog.controller.js